import { useLayoutEffect, useState, type FC } from 'react';
import { NavLink } from 'react-router-dom';
import { Preview } from '@features/product';
import { ArrowProductRight } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks';
import { QuantityInput } from 'library/components/common';
import { Spinner, Table } from 'library/components/shop';
import { useProduct } from 'library/hooks/shop';
import ButtonAddToCart from './frames/ButtonAddToCart';
import Description from './frames/Description';
import Presentation from './frames/Presentation';
import Price from './frames/Price';
import Specifications from './frames/Specifications';
import Specs from './frames/Specs';
import Storage from './frames/Storage';
import Tabs from './frames/Tabs';
import * as st from './styles.module.scss';

export const Product: FC = () => {
  const product = useProduct();
  const windowWidth = useWindowWidth();

  const InitialStateTab: string | null = product.info.description
    ? 'description'
    : !product.info.description && product.info.specifications
      ? 'specifications'
      : null;

  const [tab, setTab] = useState<string | null>(null);

  const tabs = [
    product.info.description ? 'description' : null,
    product.info.specifications ? 'specifications' : null,
  ];

  useLayoutEffect(() => {
    if (tab === null) setTab(InitialStateTab);
  }, [product]);

  return (
    <>
      {windowWidth <= 768 ? (
        <>
          {product.status === 'loading' && (
            <div className={st.spinner}>
              <Spinner />
            </div>
          )}
          {product.status === 'loaded' && (
            <>
              <section className={st.product}>
                <section className={st.headerBlock}>
                  <header className={st.header}>{product.info.title}</header>
                  <article className={st.article}>Артикул: {product.productId}</article>
                </section>
                {/* <section className={st.card}> */}
                <section className={st.imageDiv}>
                  <section className={st.card__image}>{<Preview id={product.productId} />}</section>
                  {product.tables.length ? (
                    <section className={st.cart__table}>
                      <Table tables={product.tables} />
                    </section>
                  ) : null}
                </section>
                {/* </section> */}
                <section className={st.card__data}>
                  {product.attributes && product.attributes.length > 0 && (
                    <section className={st.card__specs}>
                      <Specs
                        attributes={product.attributes}
                        showSelectNote={product.showSelectNote}
                        storage={product.storage}
                      />
                    </section>
                  )}
                  <section className={st.card__quantity}>
                    <div>Количество</div>
                    <QuantityInput
                      value={product.quantity}
                      setValue={product.setQuantity}
                      maxQuantity={product.attributesSelected ? product.selectedQuantity : Infinity}
                      defaultValue="1"
                    />
                    <Storage
                      quantity={product.selectedQuantity}
                      attributesSelected={product.attributesSelected}
                    />
                  </section>
                  <section className={st.card__buy}>
                    <Price
                      quantity={product.quantity}
                      price={product.price.amount}
                      partnerPrice={product.price.partner_amount}
                    />
                    <ButtonAddToCart
                      onClick={product.sendToCart}
                      storage={product.filterdStorage}
                      setShowSelectNote={product.setShowSelectNote}
                      showSelectNote={product.showSelectNote}
                      attributesSelected={product.attributesSelected}
                    />
                  </section>
                </section>
                <section className={st.product__data_main}>
                  {product.info.description ? (
                    <NavLink to={`description#`} className={st.data}>
                      Описание
                      <ArrowProductRight />
                    </NavLink>
                  ) : null}
                  {product.info.specifications ? (
                    <NavLink to={`specification#`} className={st.data}>
                      Характеристики
                      <ArrowProductRight />
                    </NavLink>
                  ) : null}
                  {product.media.presentation && product.media.presentation !== 'null' && (
                    <a
                      className={st.data}
                      href={product.media.presentation}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Смотреть презентацию
                      <ArrowProductRight />
                    </a>
                  )}
                </section>
              </section>
            </>
          )}
        </>
      ) : (
        <>
          <header className={st.header}>{product.info.title}</header>
          <article className={st.article}>Артикул: {product.productId}</article>
          {product.status === 'loading' && (
            <div className={st.spinner}>
              <Spinner />
            </div>
          )}
          {product.status === 'loaded' && (
            <>
              <section className={st.product}>
                <section>
                  <section className={st.card}>
                    <section className={st.card__image}>
                      {<Preview id={product.productId} />}
                    </section>
                    <section className={st.card__data}>
                      {product.attributes && product.attributes.length > 0 && (
                        <section className={st.card__specs}>
                          <Specs
                            attributes={product.attributes}
                            showSelectNote={product.showSelectNote}
                            storage={product.storage}
                          />
                        </section>
                      )}
                      <section className={st.card__quantity}>
                        <div>Количество</div>
                        <QuantityInput
                          value={product.quantity}
                          setValue={product.setQuantity}
                          maxQuantity={
                            product.attributesSelected ? product.selectedQuantity : Infinity
                          }
                          defaultValue="1"
                        />
                        <Storage
                          quantity={product.selectedQuantity}
                          attributesSelected={product.attributesSelected}
                        />
                      </section>
                      <section className={st.card__buy}>
                        <Price
                          quantity={product.quantity}
                          price={product.price.amount}
                          partnerPrice={product.price.partner_amount}
                        />
                        <ButtonAddToCart
                          onClick={product.sendToCart}
                          storage={product.filterdStorage}
                          setShowSelectNote={product.setShowSelectNote}
                          showSelectNote={product.showSelectNote}
                          attributesSelected={product.attributesSelected}
                        />
                      </section>
                    </section>
                    {product.tables.length ? (
                      <div className={st.cart__table}>
                        <Table tables={product.tables} />
                      </div>
                    ) : null}
                  </section>
                  <section className={st.buttons}>
                    <Tabs tabs={tabs} selected={tab} setTab={setTab} />
                    {product.media.presentation && product.media.presentation !== 'null' && (
                      <Presentation presentation={product.media.presentation} />
                    )}
                  </section>
                </section>
                <section>
                  {tab === 'description' && product.info.description && (
                    <Description text={product.info.description} />
                  )}
                  {tab === 'specifications' && product.info.specifications.length > 0 && (
                    <Specifications specifications={product.info.specifications} />
                  )}
                </section>
              </section>
            </>
          )}
        </>
      )}
    </>
  );
};
